export default {
    'export': 'Export',
    'export-as-excel': 'Export as excel file',
    'print-the-account-custom-statement': 'Print customised account statement',
    'custom-statements': 'Customised statements',
    'balanced-accounts-only': 'Only accounts with balances',
    'show-all-columns': 'Show all columns',
    refresh: 'Refresh',

    'total-debit-balance': 'Total debit balance:',
    'total-credit-balance': 'Total credit balance:',

    headers: {
        'account-no': 'ID',
        'account-name': 'Account name',
        'parent-account': 'Main account',
        'debit-balance': 'Debit balance',
        'credit-balance': 'Credit balance',
        'last-debit-amount': 'Last debit activity',
        'last-debit-date': 'Date of last debit activity',
        'last-credit-amount': 'Last credit activity',
        'last-credit-date': 'Date of last credit activity',
    },

    'sum-debit-credit-result-headers': {
        'sum-debits': 'Total Debit',
        'sum-credits': 'Total Credit',
        'debit-balance': 'Debit balance',
        'credit-balance': 'Credit balance',
    }
}